<div style="display: flex;flex-direction: row; flex-wrap: wrap;justify-content: space-around;">
  <div class="canvas-style" >
    <span class="title">{{debutSemaine | date:"dd/MM/YYYY"}} -- {{finSemaine | date:"dd/MM/YYYY"}}</span>
<canvas #patientCanvas></canvas>  </div>
  <app-rounder-patient></app-rounder-patient>
</div>

  